
  import QuestionTitle from '@/ui/components/inspectionReport/items/QuestionTitle.vue';
  import { computed, defineComponent, inject } from 'vue';
  import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
  import TableBox from '@/ui/components/inspectionReport/items/table/TableBox.vue';
  import { ImageAsset } from '@/ui/components/asset/ImageAsset';
  import { Action } from '@/ui/components/inspectionReport/items';
  import { isPdf } from '@/ui/helpers/systemHelper';
  import { isLowQualityImagesFromReportPageKey } from '@/ui/injectionKeys';

  interface EntityItemProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: {[key: string]: any};
  }

  export default defineComponent<EntityItemProps>({
    name: 'EntityItem',
    components: { QuestionTitle, ImageAsset, TableBox, Action },
    props: ['item'],
    setup(props) {
      const isLowQualityImages = isPdf && inject(isLowQualityImagesFromReportPageKey, false);
      const { resource, resourceIssues } = useInspectionReport();
      const mappedItems = computed(() => props.item?.response?.map((id: number) => {
        return resource.value?.entity_items[id];
      }));

      const inFormIssue = resource.value!.template?.display_issues
        && resourceIssues.value.find(issue => issue.payload && issue.payload.item_uuid === props.item.uuid);

      return {
        isLowQualityImages,
        mappedItems,
        resource,
        inFormIssue,
      };
    },
  });
